import React, { useState } from "react";
import { Link } from "react-router-dom"; // Assuming you're using React Router
import SocialLoginProviders from "./SocialLoginProviders"; // Component for social login
import { loginUser } from "../api/auth"; // API function to handle login
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS


const Login = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await loginUser(formData);
      window.location.href = "/dashboard"; // Redirect on success
    } catch (err) {
      setError("Invalid email or password");
    }
    setLoading(false);
  };

  return (
    <div className="row justify-content-center">
      <div className="col-lg-6">
        <div className="card">
          <h3 className="card-header">Login</h3>
          <div className="card-body">
            <p className="card-text">Welcome Back!</p>
            <div className="alert alert-info text-muted">
              New here? Head over to the <Link to="/signup" className="text-primary">sign up</Link> page first.
            </div>
          </div>

          {/* Social Login Section */}
          <div className="card-body">
            <h5 className="card-text">Social Accounts</h5>
            <SocialLoginProviders />
          </div>

          {/* Classic Login Form */}
          <div className="card-body">
            <h5 className="card-text">The Classic Way</h5>
            {error && <div className="alert alert-danger">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Password</label>
                <input
                  type="password"
                  className="form-control"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
              </div>
              <button className="btn btn-outline-primary" type="submit" disabled={loading}>
                {loading ? "Signing In..." : "Sign In"}
              </button>
            </form>
            <br />
            <Link to="/reset-password" className="btn btn-link">Forgot Password?</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;